const tabs = {
    tabs: document.querySelectorAll('.jsTab') as NodeListOf<HTMLElement>,
    conts: document.querySelectorAll('.jsTabsBody') as NodeListOf<HTMLElement>,
    tabsArrivals: document.querySelectorAll('.jsTabArrivals') as NodeListOf<HTMLElement>,
    contsArrivals: document.querySelectorAll('.jsTabsBodyArrivals') as NodeListOf<HTMLElement>,
  
    init() {
      this.setArrivalTabs();
      this.setTabs();
      this.resetTabs();
    },
  
    resetTabs() {
      window.addEventListener('reset', () => {
        this.setArrivalTabs();
        this.setTabs();
      });
    },
  
    setTabs() {
      this.tabs.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.tabs.forEach((item, index) => {
            item.classList.remove('activeClass');
            this.conts[index].classList.remove('activeClass');
          });
          item.classList.add('activeClass');
          this.conts[index].classList.add('activeClass');
        });
      });
    },

    setArrivalTabs() {
      this.tabsArrivals.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.tabsArrivals.forEach((item, index) => {
            item.classList.remove('activeClass');
            this.contsArrivals[index].classList.remove('activeClass');
          });
          item.classList.add('activeClass');
          this.contsArrivals[index].classList.add('activeClass');
        });
      });
    }
  };
  
  export default tabs;
  